import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../reducers';
import * as fromAuth from '../../../auth/reducers';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent {
  tenantName$: Observable<string>
  fullWidthView$: Observable<boolean>
  impressumLink: string;
  hasImpressumLink: boolean;
  datenSchutzLink: string;
  hasDatenSchutzLink: boolean;

  constructor(private store: Store<any>, private translate: TranslateService) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )

    this.tenantName$ = store
      .pipe(
        select(fromAuth.getCurrentTenantName)
      )

    this.translate.stream(['footer.impressumlink', 'footer.datenschutzlink']).subscribe((result) => {
      this.impressumLink = result['footer.impressumlink'];
      this.hasImpressumLink = this.impressumLink && this.impressumLink.startsWith('http');

      this.datenSchutzLink = result['footer.datenschutzlink'];
      this.hasDatenSchutzLink = this.datenSchutzLink && this.datenSchutzLink.startsWith('http')
    })
  }
}
